import { z } from "zod";

export const SubcontaSimplificadoSchema = z.object({
    codigo: z.coerce.string().nonempty("Código é obrigatório."),
    ativo: z.coerce.number().default(1),
    idSubcontaPai: z.coerce.number().nullable().default(null),
    descricao: z.coerce.string().nullable().default(null),

});

export type SubcontaSimplificadoForm = z.infer<typeof SubcontaSimplificadoSchema>;

export const defaultSubcontaSimplificadoForm: Partial<SubcontaSimplificadoForm> = {
    idSubcontaPai: null,
    ativo: 1,
    descricao: null,

}